// src/pages/Board.js
import React from 'react';
import ButtonLink from '../components/Button';

const Board = () => {
  return (
    <div className="page board-page">
      <section className="page-header">
        <div className="container">
          <h1>Board documents</h1>
          <p>Resources for Integralis board members</p>
        </div>
      </section>

      <section className="content-section">
        <div className="container">
          <div className="info-card">
            <h3>Board resources</h3>
            <ul className="documents-list">

              <li className="documents-item">
                <ButtonLink href="https://forms.office.com/Pages/ResponsePage.aspx?id=WXWumNwQiEKOLkWT5i_j7t9SiynT9gRLqlqJx_OKFhlUNTk1QzU3ODBKTjAzT1NEOTlGVTRUMjVEOCQlQCN0PWcu">
                  Expense claim form
                </ButtonLink>
              </li>

              <li className="documents-item">
                <ButtonLink href="https://forms.office.com/e/rQsdkpTLm6">
                  Billing form
                </ButtonLink>
              </li>

              <li className="documents-item">
                <ButtonLink href="https://helsinkifi.sharepoint.com/sites/Integralis/Shared%20Documents/Forms/AllItems.aspx">
                  Board SharePoint
                </ButtonLink>
              </li>

            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Board;
